import { render, staticRenderFns } from "./model-search.vue?vue&type=template&id=1846209a&"
import script from "./model-search.vue?vue&type=script&lang=js&"
export * from "./model-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports